export const image = {
	default: 'https://storage.googleapis.com/tirx-resources-develop/817f55db-81a6-46a4-affd-ac46d05deaa0.png',
};
